import Operator from '../models/Operator'
const state = {
  operators: [],
};

const mutations = {
  'SET_OPERATORS'(state, operators) {
    state.operators = operators
  },
};

const actions = {
  async set_operators({commit}) {
    try {
      let operators = await Operator.all(`sort=name%7Casc&page=1&per_page=999&filter=`)
      commit('SET_OPERATORS', operators.data)
      return operators.data
    } catch (e) {
      return e
    }
  },
}

const getters = {
  operators: state => {
    return state.operators
  },
};

export default {
  state,
  mutations,
  actions,
  getters
};
